var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"home",staticClass:"index"},[_c('Header',{attrs:{"scrollTops":_vm.scrollTops}}),_c('carousel'),_c('product',{attrs:{"id":"product"}}),_c('serVice'),_c('exhibition'),_c('About'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }